export const easingSeconds = "0.6s";
